import { type ApiResult, type BaseParams, type GetInviteDataResponse } from '@app/client/common/structs';

import { apiFactory } from '../../ApiFactory';
import { Request } from '../../common/api';
import { links } from '../../links';

function getInviteData(params: BaseParams): Promise<ApiResult<GetInviteDataResponse>> {
    return Request.getRequest({
        ...params,
        target: links.invites().inviteData(),
        settings: {
            ...params.settings,
        },
    });
}

export async function callGetInviteData(): Promise<GetInviteDataResponse> {
    return apiFactory()
        .call(getInviteData, {})
        .then((result) => {
            if (result.ok) {
                return result.value;
            }
            const errorMessage = result?.error?.detail ?? 'Error getting invite data';
            throw new Error(errorMessage);
        });
}
